import PrivacyPolicyContainer from "@containers/PrivacyPolicyContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import { getServer } from "@translations/next";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";
import _ from "lodash";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <LocomotiveProvider
        options={{
          smooth: true,
          getSpeed: true,
          getDirection: true,
          reloadOnContextChange: true,
          mobile: {
            smooth: true,
          },
          tablet: {
            smooth: true,
          },
        }}
      >
        <PrivacyPolicyContainer />
      </LocomotiveProvider>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "group-privacy-policy");
  const res = await StrapiService.find({ populate: "deep", locale });
  const footerData = await FooterService.fetchByHotel(undefined, locale);
  return {
    pageData: _.get(res, "data", {}),
    footerData,
  };
});
